import { useContext, useEffect, useState } from "react";
import {
  Keyboard,
  ScrollView,
  StyleSheet,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

import IconButton from "../../components/ButtonIcon";
import CreditCard from "../../components/CreditCard";
import { SaveCard } from "../../services/Api/card";
import { Encrypt } from "../../services/Crypt";
import * as Colors from "../../styles/colors";

import PageTitle from "../../components/PageTitle";
import { GlobalContext } from "../../contexts/global";
import GetCardType from "../../helpers/creditCard";
import { checkCreditCard } from "../../helpers/creditCardValid";
import Validade from "../../helpers/validate";
import CardForm from "./components/CardForm";
import { IS_WEB } from "@services/Config";

export default function CreditCardForm({ navigation, route }) {
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setCardName] = useState("");
  const [cardDocument, setCardDocument] = useState("");
  const [cardExpiration, setCardExpiration] = useState("");
  const [cardBrand, setCardBrand] = useState("");
  useEffect(() => setLoading({
    show: false,
    message: "Salvando seu cartão",
  }), [])

  const [validCardNumber, setValidCardNumber] = useState({
    isValid: true,
    invalidMessage: "Digite um cartão válido",
  });
  const [validCardName, setValidCardName] = useState({
    isValid: true,
    invalidMessage: "Digite um nome válido",
  });
  const [validCardExpiration, setValidCardExpiration] = useState({
    isValid: true,
    invalidMessage: "Digite uma data válida",
  });
  const [validCardDocument, setValidCardDocument] = useState({
    isValid: true,
    invalidMessage: "Documento inválido",
  });

  const checkExpiration = (monthAndyear) => {
    try {
      if (!monthAndyear) return true;
      if (monthAndyear.lenght < 5) return true;
      let monthExpiration = parseInt(monthAndyear.substring(0, 2)) - 1;
      let yearExpiration = "20" + monthAndyear.substring(3, 5);
      let todayDate = new Date();
      let expirationDate = new Date();
      expirationDate.setFullYear(yearExpiration, monthExpiration, 1);
      return expirationDate < todayDate;
    } catch (error) {
      return true;
    }
  };

  const validData = () => {
    let valid = true;
    let cardBrandType = GetCardType(cardNumber.replace(/\s/g, ""));
    setCardBrand(cardBrandType);
    let checkNumber = checkCreditCard(cardNumber, cardBrandType);
    //Card number
    if (!checkNumber.valid) {
      valid = false;
      setValidCardNumber({
        isValid: checkNumber.valid,
        invalidMessage: checkNumber.message,
      });
    } else {
      setValidCardNumber({ ...validCardNumber, isValid: true });
    }
    //Card Name
    if (cardName == "") {
      valid = false;
      setValidCardName({ ...validCardName, isValid: false });
    } else setValidCardName({ ...validCardName, isValid: true });
    //Card Expiration
    if (checkExpiration(cardExpiration)) {
      setValidCardExpiration({ ...validCardExpiration, isValid: false });
    } else setValidCardExpiration({ ...validCardExpiration, isValid: true });

    if ((!Validade.validDocument(cardDocument))) {
      valid = false;
      setValidCardDocument({ ...validCardDocument, isValid: false });
    } else setValidCardDocument({ ...validCardDocument, isValid: true });

    if (valid) {
      saveCardApi(cardBrandType);
    }
  };

  const saveCardApi = (cardBrandType) => {
    setLoading({ show: true, message: "Salvando o cartão" });
    SaveCard(
      cardName,
      cardDocument,
      Encrypt(cardNumber.replace(/\s/g, "")),
      cardExpiration,
      cardBrandType,
    )
      .then((value) => {
        setShowAlert({
          type: "success",
          title: "Sucesso",
          message: "Cartão salvo com sucesso.",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
            return navigation.goBack();
          },
        });
      })
      .catch((value) => {
        setShowAlert({
          type: "alert",
          title: "Erro ao salvar o cartão",
          message: value.erro ? value.erro : "Não informado",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      })
      .finally(() => {
        setLoading({ show: false, message: "Salvando o cartão" });
      });
  };

  const props = {
    cardNumber,
    setCardNumber,
    validCardNumber,
    cardExpiration,
    setCardExpiration,
    validCardExpiration,
    cardName,
    setCardName,
    validCardName,
    cardDocument,
    setCardDocument,
    validCardDocument
  };

  return (
    <PageTitle title={"NOVO CARTÃO"} navigation={navigation}>
      <KeyboardAwareScrollView
        style={{ flex: 1, backgroundColor: Colors.WHITE }}
        keyboardShouldPersistTaps={"always"}
      >
        <TouchableWithoutFeedback onPress={!IS_WEB ? Keyboard.dismiss : null}>
          <ScrollView keyboardShouldPersistTaps={"always"}>
            <View style={styles.viewData}>
              <CreditCard
                number={cardNumber}
                name={cardName}
                expiration={cardExpiration}
              />
              <CardForm {...props} />
              <IconButton
                textoBotao={"Salvar cartão"}
                iconName={"content-save"}
                onPress={() => validData()}
                estilo={{ backgroundColor: Colors.SUCCESS, width: "100%" }}
              />
            </View>
          </ScrollView>
        </TouchableWithoutFeedback>
      </KeyboardAwareScrollView>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  viewData: {
    marginVertical: 8,
    flex: 1,
    justifyContent: "center",
  },
});
